export enum EMintType {
    DEFAULT = "default",
    SCRATCHER = "scratcher",
}
